import { apiRequest } from "./client";

export interface AuthUser {
  id: number;
  email: string;
  name: string | null;
  firstName: string | null;
  imageUrl: string | null;
  isPaying: boolean;
  isChartmetricEmail: boolean;
}

export interface LoginResponse {
  user: AuthUser | null;
  requiresCode: boolean;
}

export async function fetchMe(signal?: AbortSignal): Promise<AuthUser | null> {
  try {
    return await apiRequest<AuthUser>("/api/auth/me", { signal });
  } catch {
    return null;
  }
}

export function login(payload: {
  email: string;
  password: string;
  code?: string;
}): Promise<LoginResponse> {
  return apiRequest<LoginResponse>("/api/auth/login", {
    method: "POST",
    body: payload,
  });
}

export function logout(): Promise<void> {
  return apiRequest<void>("/api/auth/logout", { method: "POST" });
}
